import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
  multipleIssueTypesLabel: {
    id: 'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel',
    defaultMessage: '{count} issue types',
    description: 'The text displayed on the issue type label when there are multiple issue types in non-JSM projects.'
  },
  multipleRequestTypesLabel: {
    id: 'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel',
    defaultMessage: '{count} request types',
    description: 'The text displayed on the request type label when there are multiple request types in JSM projects.'
  }
});